import { lazy, Suspense } from "react";
import classNames from "classnames";

// Hooks
import useTranslate from "../../../hooks/useTranslate";

import "./styles.sass";

// Icons
const LazyArrow = lazy(() => import("assets/icons/arrow.svg?react"));

type MobilePaginatorElementProps = {
  currentPage: number;
  lastPage: number;
  onClick: (selectedItem: { selected: number }) => void;
};

const MobilePaginatorElement = ({
  currentPage,
  lastPage,
  onClick,
}: MobilePaginatorElementProps) => {
  const t = useTranslate();
  const safeCurrentPage = Math.min(currentPage, lastPage);

  const handlePageClick = (selectedItem: { selected: number }) => {
    const newPage = selectedItem.selected + 1;
    if (newPage <= lastPage) {
      onClick(selectedItem);
    }
  };

  const isPrevDisabled = safeCurrentPage <= 1;
  const isNextDisabled = safeCurrentPage >= lastPage;

  const lastPageClass = classNames("pagination-page-indicator__last", {
    active: currentPage === lastPage,
  });

  return (
    <div className="mobile-pagination">
      {/* eslint-disable-next-line react/button-has-type */}
      <button
        onClick={() =>
          !isPrevDisabled && handlePageClick({ selected: safeCurrentPage - 2 })
        }
        className="pagination-link__prev"
      >
        <Suspense fallback="">
          <LazyArrow
            className={`pagination-arrow ${isPrevDisabled ? "pagination-arrow_disabled" : ""}`}
          />
        </Suspense>
        <span className="pagination-link__text">
          {t("year.leadersboard.prev")}
        </span>
      </button>
      <span className="pagination-page-indicator">
        <span className="pagination-page-indicator__current">
          {safeCurrentPage} /
        </span>
        &nbsp;
        <span className={lastPageClass}>{lastPage}</span>
      </span>
      {/* eslint-disable-next-line react/button-has-type */}
      <button
        onClick={() =>
          !isNextDisabled && handlePageClick({ selected: safeCurrentPage })
        }
        className="pagination-link__next"
      >
        <span className="pagination-link__text">
          {t("year.leadersboard.next")}
        </span>
        <Suspense fallback="">
          <LazyArrow
            className={`pagination-arrow_next ${isNextDisabled ? "pagination-arrow_disabled" : ""}`}
          />
        </Suspense>
      </button>
    </div>
  );
};

export default MobilePaginatorElement;
